import { Component } from '@theme/component';

/**
 * Selector for the UserWay widget's floating icon (the element `iconVisibilityOff()` toggles).
 */
const WIDGET_ICON_SELECTOR = '#userwayAccessibilityIcon';

/**
 * A custom element that opens the UserWay accessibility menu from the footer, in place of the
 * widget's floating icon.
 *
 * It stays hidden until the widget has rendered, so there is never a dead control when the widget is
 * blocked or fails to load, and the floating icon is only hidden once this trigger is on screen
 * to replace it.
 *
 * @extends {Component}
 */
class AccessibilityTrigger extends Component {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('userway:render_completed', this.#takeOverFromIcon);

    // The widget loads asynchronously and may have rendered before this element connected.
    if (document.querySelector(WIDGET_ICON_SELECTOR)) this.#takeOverFromIcon();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('userway:render_completed', this.#takeOverFromIcon);
  }

  /**
   * Hides the widget's floating icon and reveals this trigger. `iconVisibilityOff()` only toggles a
   * class on the icon element, so it must not run until the widget has rendered that element.
   */
  #takeOverFromIcon = () => {
    if (!window.UserWay) return;

    window.UserWay.iconVisibilityOff();
    this.hidden = false;
  };

  /**
   * Opens the accessibility menu.
   */
  open = () => {
    window.UserWay?.widgetOpen();
  };
}

if (!customElements.get('accessibility-trigger')) {
  customElements.define('accessibility-trigger', AccessibilityTrigger);
}
